import React from "react";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import {  IconButton, Typography } from "@mui/material";
import {
  CloseIcon,
  EmptyTimeSheetReportList,
  ReloadIcon
} from "../../../assets/images";
import DrawerLoader from "../../commons/DrawerLoader/DrawerLoader";
import SingleUpdatedByDetails from "./SingleUpdatedByDetails";
import "./styles.scss";
import { EmptyListPage } from "../../commons";

type CustomDrawerProps = {
  isRight: boolean;
  isOpen: boolean;
  onClose: (type: string, id?: number) => void;
  history: any;
  clientCode: number | null;
  fetching: boolean;
  handleLoadMore: () => void;
  invoiceHistoryCount: number;
  invoiceHistoryOffset: number;
  invoiceHistoryLimit:number;
};

const InvoiceHistory: React.FC<CustomDrawerProps> = ({
  isRight,
  isOpen,
  onClose,
  history,
  clientCode,
  fetching,
  handleLoadMore,
  invoiceHistoryCount,
  invoiceHistoryOffset,
  invoiceHistoryLimit
}) => {
  const LocalDrawerContent = (
    <Box
      className="invoice_history"
      sx={{
        width: 800,
        padding: "0px 16px",
        marginTop:"16px",
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 2,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent:"space-between" ,width:"100%"}}>
          <div style={{ display: "flex", alignItems: "center", gap: "17px" }}>
          <IconButton onClick={() => onClose("close")}>
            <img width={"150%"} src={CloseIcon} alt="Close Icon" />
          </IconButton>

          <Typography variant="h6" sx={{ fontSize: "22px", fontWeight: "500" }}>
            Invoice Audit
          </Typography>
          </div>
         
          <Box
          onClick={
            invoiceHistoryOffset + invoiceHistoryLimit >= invoiceHistoryCount
              ? undefined
              : handleLoadMore
          }
          style={{
            display: "flex",
            border: "1px solid #DD4433",
            padding: "5px 8px",
            borderRadius: "4px",
            cursor: "pointer",
            background:
              invoiceHistoryOffset + invoiceHistoryLimit >= invoiceHistoryCount
                ? "rgba(0, 0, 0, 0.05)"
                : "#fff",
          }}
        >
          {" "}
          <img src={ReloadIcon} alt="reload" />{" "}
          <Typography
            sx={{
              color: "#DD4433",
              fontSize: "15px",
              fontWeight: 500,
              paddingLeft: "4px",
            }}
          >
            Load More
          </Typography>

        </Box>

        </div>
      </Box>
      <hr style={{ margin: "2px 0px" }} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "2px",
        }}
      >
       {history?.length>0 ? <Typography
          variant="h6"
          className="pt-2 pl-3"
          sx={{ fontSize: "18px", fontWeight: "500", color: "#6e7491" }}
        >
          Find Invoice history below for selected invoice.
        </Typography> : null}
        
      </Box>
      {fetching && <DrawerLoader />}

      {history?.length>0 ? history?.map((item: any, index: number) => {
        return (
          <SingleUpdatedByDetails history={history} data={item} index={index} />
        );
      }) :  
      <div className="mt-5">
      <EmptyListPage
      title="No Invoice Audit Found!"
      text="Upload some data to view history !"
      imageWidth="30%"
      image={EmptyTimeSheetReportList}
      showAddButton={false}
      /></div>}
      <div></div>
    </Box>
  );
  return (
    <div>
      {isRight && (
        <>
          <Drawer anchor="right" open={isOpen} onClose={() => onClose("close")}>
            {LocalDrawerContent}
          </Drawer>
        </>
      )}
    </div>
  );
};

export default InvoiceHistory;
